import c from '../common';

export default{
    "tmr": "明天",
    "booking": "預約總數",

    "untilToday":"截至今日",

    "NA": c.NA.chn,

    "QTY":"張",

    "IN_STORE_REDEEM":"門店換領",
    "DELIVERY_REDEEM":"送貨",

};